import { useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { landingPageDesignsKeys } from './landingPageDesignsKeys';

type Source = 'LandingPageDesign' | 'Customer' | 'Reseller';

export interface IAutocompleteResponse {
  name: string;
  source: Source;
}

export interface ILandingPageDesignsAutocompleteQueryParams {
  start?: number;
  limit?: number;
  search: string;
}

export const getLandingPageDesignsAutocomplete = async (
  props: ILandingPageDesignsAutocompleteQueryParams
): Promise<IAutocompleteResponse[]> => {
  const { search, limit, start } = props;
  const params = {
    search,
    limit,
    start,
  };

  return (
    await EXPRESS_API.get(`/superadmin/landing-page-designs/autocomplete`, {
      params,
    })
  ).data;
};

export const useQueryLandingPageDesignsAutocomplete = (
  params: ILandingPageDesignsAutocompleteQueryParams,
  enabled: boolean = true
) => {
  return useQuery(
    landingPageDesignsKeys.autocomplete({
      search: params.search || '',
    }),
    () => getLandingPageDesignsAutocomplete(params),
    {
      refetchOnMount: true,
      staleTime: 0,
      enabled,
      onError: () => {
        errorToast({
          title:
            "We're currently experiencing difficulties fetching landing page design autocomplete",
        });
      },
    }
  );
};
